import {
  PRODUCT_IMPRINT_URL,
  PRODUCT_PRIVACY_URL,
  PRODUCT_SUPPORT_URL,
  PRODUCT_TERMS_URL,
} from '@core/constant/branding';
import { For, Show } from 'solid-js';

/** Document links are informational; sign-in does not record legal consent. */
export function ProductLegalNotice() {
  return (
    <>
      Legal information:{' '}
      <For
        each={[
          { label: 'Terms', href: PRODUCT_TERMS_URL },
          { label: 'Privacy policy', href: PRODUCT_PRIVACY_URL },
          { label: 'Imprint', href: PRODUCT_IMPRINT_URL },
        ]}
      >
        {(link) => (
          <Show when={link.href}>
            {(href) => (
              <>
                <a
                  href={href()}
                  target="_blank"
                  rel="noopener noreferrer"
                  class="underline underline-offset-2 hover:text-ink-muted"
                >
                  {link.label}
                </a>
                {' · '}
              </>
            )}
          </Show>
        )}
      </For>
      <a
        href={PRODUCT_SUPPORT_URL}
        class="underline underline-offset-2 hover:text-ink-muted"
      >
        Contact the operator
      </a>
      .
    </>
  );
}
